import version_ from "../assets/build-version.json";

export type BuildVersion = Partial<{
  timestamp: string;
  packageVersion: string;
  buildVersion: string;
}>;

export const version = version_ as BuildVersion;
